import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { requestData } from "@/api/api-config";
export interface PatientCreditReason {
  id: string;
  name: string;
  isArchived: boolean;
  position: number;
}
const listPatientCreditReasons = (): Promise<PatientCreditReason[] | null> => requestData<PatientCreditReason[]>("settings/patient-credit-reasons", "get", undefined, false);
export const patientCreditReasonQueryKeys = {
  all: ["settings", "patientCreditReasons"] as const
};
export const patientCreditReasonQueryOptions = {
  list: () => ({
    queryKey: patientCreditReasonQueryKeys.all,
    queryFn: listPatientCreditReasons
  })
};
export const useCreatePatientCreditReasonMutation = () => {
  const $ = _c(2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = {
      mutationFn: _temp,
      onSuccess: reason => {
        if (reason) {
          queryClient.setQueryData(patientCreditReasonQueryKeys.all, t1 => {
            const old = t1 === undefined ? [] : t1;
            return [...old, reason];
          });
        }
      }
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};
export const useRenamePatientCreditReasonMutation = () => {
  const $ = _c(2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = {
      mutationFn: _temp2,
      onSuccess: reason => {
        if (reason) {
          queryClient.setQueryData(patientCreditReasonQueryKeys.all, t1 => {
            const old = t1 === undefined ? [] : t1;
            return old.map(existing => existing.id === reason.id ? reason : existing);
          });
        }
      }
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};
export const useArchivePatientCreditReasonMutation = () => {
  const $ = _c(2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = {
      mutationFn: _temp3,
      onSuccess: (_result, id_0) => {
        queryClient.setQueryData(patientCreditReasonQueryKeys.all, t1 => {
          const old = t1 === undefined ? [] : t1;
          return old.filter(reason => reason.id !== id_0);
        });
      }
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};
function _temp(name) {
  return requestData("settings/patient-credit-reasons", "post", {
    json: {
      name
    }
  }, false);
}
function _temp2(t0) {
  const {
    id,
    name
  } = t0;
  return requestData(`settings/patient-credit-reasons/${id}`, "patch", {
    json: {
      name
    }
  }, false);
}
function _temp3(id) {
  return requestData(`settings/patient-credit-reasons/${id}`, "delete", undefined, false);
}